module.exports = __webpack_public_path__ + "img/uy.7bd678ed.svg";